import { render, staticRenderFns } from "./_404.vue?vue&type=template&id=872a7f84"
import script from "./_404.vue?vue&type=script&lang=js"
export * from "./_404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports